import { Component, Input, OnInit } from '@angular/core';
import { interval, map, take } from 'rxjs';

@Component({
  selector: 'app-number-animation',
  templateUrl: './number-animation.component.html',
  styleUrls: ['./number-animation.component.scss'],
})
export class NumberAnimationComponent implements OnInit {
  animatedNumber = 0;
  @Input() autorefresh = false;
  @Input() targetNumber = 0; // Set your target number here
  @Input() suffix = ''; // Set your target number here
  duration = 1500; // Animation duration in milliseconds

  ngOnInit(): void {
    this.animateNumber(this.targetNumber, this.duration);
  }

  animateNumber(target: number, duration: number): void {
    if (!this.autorefresh) {
      const frameRate = 16; // Milisegundos por frame (~60fps)
      const totalFrames = Math.ceil(duration / frameRate);

      interval(frameRate)
        .pipe(
          take(totalFrames),
          map((frame) => {
            const progress = frame / totalFrames;
            const easedProgress = this.easeOutCubic(progress); // Usar easing más fuerte
            return Math.min(target, easedProgress * target);
          })
        )
        .subscribe((value) => (this.animatedNumber = Math.round(value)));
    } else {
      this.animatedNumber = target;
    }
  }

  /**
   * Efecto de Ease-Out Cuadrático
   * @param t - Progreso de la animación (0 a 1)
   * @returns Valor ajustado con easing cúbico
   */
  easeOutCubic(t: number): number {
    return 1 - Math.pow(1 - t, 3); // Fórmula cúbica para aumentar el easing
  }

  /**
   * Efecto de Ease-Out Cuártica (opcional)
   * @param t - Progreso de la animación (0 a 1)
   * @returns Valor ajustado con easing cuártica
   */
  easeOutQuart(t: number): number {
    return 1 - Math.pow(1 - t, 4); // Fórmula cuártica para un efecto más pronunciado
  }
}
